import SearchIcon from '@mui/icons-material/Search';
import Grid from '@mui/material/Grid';
import { useEffect, useState } from 'react';
import Modal from './ModalTicket';

const TicketHeader = () => {
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setModalOpen(false);
  }, []);

  return (
    <Grid container className='page-header'>
      <Grid size={{ xs: 12, md: 12 }}>
        <Grid container direction={'row'}>
          <Grid size={{ xs: 12, md: 6 }} textAlign={'start'}>
            <h3>Mis incidencias</h3>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }} textAlign={'end'}>
            <button className='right openModalBtn' onClick={() => setModalOpen(true)}>
              <SearchIcon className='svg' />
              Buscar número telefónico
            </button>

            {modalOpen && <Modal modalOpen={modalOpen} setOpenModal={setModalOpen} />}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TicketHeader;
